<template>
    <div class="links-wrapper">
        <link-element v-for="link,i in links"
                      :defaultClass="linksClass"
                      :key="`link-${i}`"
                      :link="link.link"/>
    </div>
</template>

<script type="module">
    import LinkElement from "./LinkElement";
    import _every from 'lodash/every';

    export default {
        name: "BlockLinks",
        components: {LinkElement},
        props: {
            linksClass: {
                type: String,
                default: 'link'
            },
            links: {
                type: Array,
                required: true,
                default: [],
                validator(val) {
                    return _every(val, element => {return element.link || false}) || false;
                }
            }
        },
        data () {
            return {}
        },
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

</style>
